import { EntityList } from '@/common/entityFramework/entityList/EntityList';

export const AesBestPriceList = () => {
  return <EntityList entity="AES_BEST_PRICE" />;
};
